import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

import baseTheme from '../Theme/baseTheme';
import IThemeInterface from '../Theme/common';

import { DeepPartial } from './Typing/tsHelpers';

export const themeMerge = (theme: DeepPartial<IThemeInterface>): IThemeInterface => (
  merge<IThemeInterface, DeepPartial<IThemeInterface>>(cloneDeep(baseTheme), theme)
);
